<template>
    <div class="container-fluid form-container fire-ex-service-form-container">
        <div class="row">
            <div class="col-sm-12">
                <h1 class="page-title">
                    Recommendations / Quotation Form
                </h1>
            </div>
        </div>

        <invoice-form :form="form" />

        <form
            action=""
            class="fire-alarm-test-form"
            @submit.prevent="saveForm()"
        >
            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-12">
                            <h3>Customer Details</h3>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-12 col-md-6 form-group">
                            <label for="customer">Customer</label>
                            <customer-search
                                ref="customerSearch"
                                :customer="form.customer"
                                @change="customerChanged"
                                :customer-id="form.customer_id"
                            />
                            <error
                                name="customer_id"
                                :errors="errors"
                            />
                        </div>
                        <div
                            class="col-sm-12 col-md-6 form-group"
                            v-if="form.customer && form.customer.sites"
                        >
                            <label for="site">Site:</label>
                            <select
                                name="site"
                                v-model="form.site_id"
                                id="site"
                                class="form-control"
                                placeholder="Site"
                                required
                                v-if="form.customer.sites.length"
                                @change="siteChanged()"
                            >
                                <option value="">
                                    Select Site
                                </option>
                                <option
                                    v-for="site in form.customer.sites"
                                    :key="site.id"
                                    :value="site.id"
                                >
                                    #{{ site.site_no }} {{ site.name }}
                                </option>
                            </select>
                            <span
                                class="form-error"
                                v-if="!form.customer.sites.length"
                            >This customer has no sites</span>
                            <error
                                name="site_id"
                                :errors="errors"
                            />
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-12 col-md-6">
                            <label for="doc_no">Report Number</label>
                            <input
                                type="text"
                                class="form-control"
                                id="doc_no"
                                v-model="form.doc_no"
                            >
                            <error
                                name="doc_no"
                                :errors="errors"
                            />
                        </div>
                        <div class="col-sm-12 col-md-6">
                            <label for="po_number">Purchase Order No.</label>
                            <input
                                type="text"
                                class="form-control"
                                id="po_number"
                                v-model="form.po_number"
                            >
                            <error
                                name="po_number"
                                :errors="errors"
                            />
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-12">
                            <h3>Job Description</h3>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-2 text-center">
                            <label class="form-check-label">New Customer</label>
                            <input
                                type="checkbox"
                                v-model="form.job_desc"
                                true-value="New Customer"
                                class="inline-control"
                            >
                        </div>
                        <div class="col-sm-2 text-center">
                            <label class="form-check-label">Call Out</label>
                            <input
                                type="checkbox"
                                v-model="form.job_desc"
                                true-value="Call Out"
                            >
                        </div>
                        <div class="col-sm-2 text-center">
                            <label class="form-check-label">Additions to Existing</label>
                            <input
                                type="checkbox"
                                v-model="form.job_desc"
                                true-value="Additions to Existing"
                                class="inline-control"
                            >
                        </div>

                        <div class="col-sm-3 text-center">
                            <label class="form-check-label">Service/Recommendation</label>
                            <input
                                type="checkbox"
                                v-model="form.job_desc"
                                true-value="Service/Recommendation"
                                class="inline-control"
                            >
                        </div>

                        <div class="col-sm-2 text-center">
                            <label class="form-check-label">Fire Report Request</label>
                            <input
                                type="checkbox"
                                v-model="form.job_desc"
                                true-value="Fire Report Request"
                                class="inline-control"
                            >
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-12">
                            <select-row-component
                                id="formulation_reason"
                                v-model="form.formulation_reason"
                                label="This recommendation/quotation was formulated due to:"
                                :options="[
                                    'Customer request',
                                    'Due system repair, does not meet current standards',
                                    'Risk assessment',
                                ]"
                                required
                            />
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12">
                            <label for="further_notes">Further notes:</label>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-12">
                            <textarea
                                v-model="form.further_notes"
                                placeholder="Write further notes here..."
                                rows="3"
                                class="form-control"
                                required
                            />
                        </div>
                    </div>
                </div>
            </div>

            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-12">
                            <h3>Fire Extinguisher Requirements</h3>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-12 col-md-10">
                            <label for="">Does the customer require a Fire Extinguisher quote?</label>
                        </div>
                        <div class="col-sm-12 col-md-2 text-right">
                            <select
                                v-model="form.quote_required"
                                @change="quoteRequiredChanged"
                                class="form-control"
                            >
                                <option
                                    disabled
                                    :value="null"
                                >
                                    Select
                                </option>
                                <option>Yes</option>
                                <option>No</option>
                            </select>
                        </div>
                    </div>

                    <div
                        class="row"
                        v-show="form.quote_required === 'Yes'"
                    >
                        <div class="col-sm-12 col-md-10">
                            <label for="">Do we already service this site?</label>
                        </div>
                        <div class="col-sm-12 col-md-2 text-right">
                            <select
                                v-model="form.site_already_serviced"
                                class="form-control"
                                @change="siteAlreadyServiceChanged"
                            >
                                <option
                                    disabled
                                    :value="null"
                                >
                                    Select
                                </option>
                                <option>Yes</option>
                                <option>No</option>
                            </select>
                        </div>
                    </div>

                    <div
                        class="row"
                        v-show="form.quote_required === 'Yes'"
                    >
                        <div class="col-sm-12">
                            <table class="service-list-table table">
                                <thead>
                                    <tr>
                                        <th>&nbsp;</th>
                                        <th
                                            class="td-no"
                                            @click.prevent="sortServiceItems('no')"
                                            :class="sortClass('no')"
                                        >
                                            No
                                        </th>
                                        <th class="td-type">
                                            Type
                                        </th>
                                        <th
                                            class="td-ltd"
                                            @click.prevent="sortServiceItems('ltd')"
                                            :class="sortClass('ltd')"
                                        >
                                            L.T.D
                                        </th>
                                        <th class="td-size">
                                            Size
                                        </th>
                                        <th
                                            class="td-location"
                                            @click.prevent="sortServiceItems('location')"
                                            :class="sortClass('location')"
                                        >
                                            Location
                                        </th>
                                        <th
                                            class="td-bs"
                                            @click.prevent="sortServiceItems('bs')"
                                            :class="sortClass('bs')"
                                        >
                                            B.S
                                        </th>
                                        <th
                                            class="td-es"
                                            @click.prevent="sortServiceItems('es')"
                                            :class="sortClass('es')"
                                        >
                                            E.S
                                        </th>
                                        <th
                                            class="td-new"
                                            @click.prevent="sortServiceItems('new')"
                                            :class="sortClass('new')"
                                        >
                                            New
                                        </th>
                                        <th
                                            class="td-rc"
                                            @click.prevent="sortServiceItems('rc')"
                                            :class="sortClass('rc')"
                                        >
                                            R.C
                                        </th>
                                        <th
                                            class="td-rcon"
                                            @click.prevent="sortServiceItems('recon')"
                                            :class="sortClass('recon')"
                                        >
                                            Rcon
                                        </th>
                                        <th
                                            class="td-non-main"
                                            @click.prevent="sortServiceItems('non_main')"
                                            :class="sortClass('non_main')"
                                        >
                                            Non-Main
                                        </th>
                                        <th class="td-fitting">
                                            Fitting
                                        </th>
                                        <th class="td-sign">
                                            I.D Sign
                                        </th>
                                        <th class="td-options">
                                        <!-- options -->
                                        </th>
                                    </tr>
                                </thead>
                                <draggable
                                    v-model="form.service_items"
                                    tag="tbody"
                                    handle=".drag-handle"
                                >
                                    <tr
                                        v-for="(item, index) in form.service_items"
                                        :key="index"
                                    >
                                        <td class="drag-handle-col">
                                            <span class="drag-handle">
                                                <i class="fas fa-arrows-alt-v" />
                                            </span>
                                        </td>
                                        <td>
                                            <input
                                                type="number"
                                                v-model="item.no"
                                                placeholder="No."
                                                class="form-control"
                                                @change="serviceItemChanged(index)"
                                                @keyup="serviceItemChanged(index)"
                                            >
                                        </td>

                                        <td style="width: 13rem">
                                            <select
                                                v-model="item.product_id"
                                                placeholder="Select type"
                                                class="form-control"
                                                @change="serviceItemChanged(index)"
                                                @keyup="serviceItemChanged(index)"
                                            >
                                                <option
                                                    value=""
                                                    disabled
                                                >
                                                    Select type...
                                                </option>
                                                <option
                                                    v-for="(product, pidx) in serviceProducts"
                                                    :value="product.id"
                                                    :key="pidx"
                                                >
                                                    {{ product.name }}
                                                </option>
                                            </select>
                                        </td>

                                        <td>
                                            <input
                                                type="text"
                                                v-model="item.ltd"
                                                placeholder="L.T.D"
                                                class="form-control"
                                                @change="serviceItemChanged(index)"
                                                @keyup="serviceItemChanged(index)"
                                            >
                                        </td>

                                        <td>
                                            <select
                                                name="size[]"
                                                v-model="item.size"
                                                class="form-control"
                                            >
                                                <option
                                                    value=""
                                                    disabled
                                                >
                                                    Select size
                                                </option>
                                                <option
                                                    :value="variation.name"
                                                    v-for="(variation, vidx) in getServiceProductVariations(item.product_id)"
                                                    :key="vidx"
                                                >
                                                    {{ variation.name }}
                                                </option>
                                            </select>
                                        </td>

                                        <td class="td-location">
                                            <input
                                                type="text"
                                                v-model="item.location"
                                                placeholder="Location"
                                                class="form-control"
                                                @change="serviceItemChanged(index)"
                                                @keyup="serviceItemChanged(index)"
                                            >
                                        </td>

                                        <td class="td-bs">
                                            <input
                                                type="checkbox"
                                                v-model="item.bs"
                                                class="form-control"
                                                @change="serviceItemChanged(index)"
                                            >
                                        </td>

                                        <td class="td-es">
                                            <input
                                                type="checkbox"
                                                v-model="item.es"
                                                class="form-control"
                                                @change="serviceItemChanged(index)"
                                            >
                                        </td>

                                        <td class="td-new">
                                            <input
                                                type="checkbox"
                                                v-model="item.new"
                                                class="form-control"
                                                @change="serviceItemChanged(index)"
                                            >
                                        </td>


                                        <td class="td-rc">
                                            <input
                                                type="checkbox"
                                                v-model="item.rc"
                                                class="form-control"
                                                @change="serviceItemChanged(index)"
                                            >
                                        </td>

                                        <td class="td-rcon">
                                            <input
                                                type="checkbox"
                                                v-model="item.rcon"
                                                class="form-control"
                                                @change="serviceItemChanged(index)"
                                            >
                                        </td>

                                        <td class="td-non-main">
                                            <input
                                                type="checkbox"
                                                v-model="item.non_main"
                                                class="form-control"
                                                @change="serviceItemChanged(index)"
                                            >
                                        </td>

                                        <td class="td-fitting">
                                            <select
                                                v-model="item.fitting"
                                                class="form-control"
                                                @change="serviceItemChanged(index)"
                                                @keyup="serviceItemChanged(index)"
                                            >
                                                <option value="" />
                                                <option value="Fitted">
                                                    Fitted
                                                </option>
                                                <option value="Required">
                                                    Required
                                                </option>
                                                <option value="Present">
                                                    Present
                                                </option>
                                            </select>
                                        </td>

                                        <td class="td-sign">
                                            <select
                                                v-model="item.id_sign"
                                                class="form-control"
                                                @change="serviceItemChanged(index)"
                                                @keyup="serviceItemChanged(index)"
                                            >
                                                <option value="" />
                                                <option value="Fitted">
                                                    Fitted
                                                </option>
                                                <option value="Required">
                                                    Required
                                                </option>
                                                <option value="Present">
                                                    Present
                                                </option>
                                            </select>
                                        </td>

                                        <td>
                                            <button
                                                class="btn btn-outline-danger btn-small"
                                                @click.prevent="removeServiceItem(index)"
                                                type="button"
                                            >
                                                <i class="fa fa-times" />
                                            </button>
                                        </td>
                                    </tr>
                                </draggable>
                            </table>

                            <div class="row">
                                <div class="col-12">
                                    <div class="text-right">
                                        <button
                                            class="btn btn-info"
                                            type="button"
                                            @click.prevent="saveSiteItems"
                                            :disabled="!form.site_id || form.service_items.length < 1"
                                        >
                                            <i class="fa fa-save" />
                                            Save items to site
                                        </button>

                                        <button
                                            class="btn btn-info"
                                            type="button"
                                            @click.prevent="addSiteItems"
                                            :disabled="!form.site_id || siteServiceItems.length === 0"
                                        >
                                            <i class="fa fa-download" />
                                            Add items from site
                                        </button>

                                        <button
                                            class="btn btn-outline-info btn-small"
                                            @click.prevent="addServiceItem()"
                                            type="button"
                                        >
                                            <i class="fa fa-plus" /> Add Item
                                        </button>

                                        <button
                                            class="btn btn-outline-primary btn-small"
                                            @click.prevent="calculateServiceItemTotals()"
                                            type="button"
                                        >
                                            <i class="fa fa-calculator" /> Recalculate Totals
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-12">
                                    <table class="table">
                                        <tr>
                                            <td rowspan="2">
                                                Totals
                                            </td>

                                            <td>Water</td>
                                            <td>
                                                <input
                                                    type="number"
                                                    step="1"
                                                    min="0"
                                                    v-model="form.water_total"
                                                    class="form-control"
                                                >
                                            </td>

                                            <td>Foam</td>
                                            <td>
                                                <input
                                                    type="number"
                                                    step="1"
                                                    min="0"
                                                    v-model="form.foam_total"
                                                    class="form-control"
                                                >
                                            </td>

                                            <td>Powder</td>
                                            <td>
                                                <input
                                                    type="number"
                                                    step="1"
                                                    min="0"
                                                    v-model="form.powder_total"
                                                    class="form-control"
                                                >
                                            </td>

                                            <td>CO2</td>
                                            <td>
                                                <input
                                                    type="number"
                                                    step="1"
                                                    min="0"
                                                    v-model="form.co2_total"
                                                    class="form-control"
                                                >
                                            </td>

                                            <td>Fitted</td>
                                            <td>
                                                <input
                                                    type="number"
                                                    step="1"
                                                    min="0"
                                                    v-model="form.fitting_fitted"
                                                    class="form-control"
                                                >
                                            </td>
                                            <td>
                                                <input
                                                    type="number"
                                                    step="1"
                                                    min="0"
                                                    v-model="form.id_sign_fitted"
                                                    class="form-control"
                                                >
                                            </td>
                                        </tr>

                                        <tr>
                                            <td>Wet Chemical</td>
                                            <td>
                                                <input
                                                    type="number"
                                                    step="1"
                                                    min="0"
                                                    v-model="form.wet_chem_total"
                                                    class="form-control"
                                                >
                                            </td>

                                            <td>Fire Blanket</td>
                                            <td>
                                                <input
                                                    type="number"
                                                    step="1"
                                                    min="0"
                                                    v-model="form.blanket_total"
                                                    class="form-control"
                                                >
                                            </td>

                                            <td>Hoses</td>
                                            <td>
                                                <input
                                                    type="number"
                                                    step="1"
                                                    min="0"
                                                    v-model="form.hoses_total"
                                                    class="form-control"
                                                >
                                            </td>

                                            <td>Screamer Alarm</td>
                                            <td>
                                                <input
                                                    type="number"
                                                    step="1"
                                                    min="0"
                                                    v-model="form.screamer_total"
                                                    class="form-control"
                                                >
                                            </td>

                                            <td>Required</td>
                                            <td>
                                                <input
                                                    type="number"
                                                    step="1"
                                                    min="0"
                                                    v-model="form.fitting_required"
                                                    class="form-control"
                                                >
                                            </td>
                                            <td>
                                                <input
                                                    type="number"
                                                    step="1"
                                                    min="0"
                                                    v-model="form.id_sign_required"
                                                    class="form-control"
                                                >
                                            </td>
                                        </tr>
                                    </table>

                                    <table class="table">
                                        <tr>
                                            <td>Codes</td>
                                            <td>B.S = Basic Service</td>
                                            <td>R.C = Recharge / Refilled</td>
                                            <td>E.S = Extended Service</td>
                                            <td>Rcon = Re-con</td>
                                            <td>Non - Main = None Maintained Fire Ex - Unable to Service Fire Ex</td>
                                        </tr>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div
                class="card"
                v-show="form.quote_required === 'Yes'"
            >
                <div class="card-body">
                    <div class="row">
                        <div class="col-12">
                            <h3>Services and Goods</h3>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <table class="table service-invoice-items-table table--fixed">
                                <thead>
                                    <tr>
                                        <th style="width: 3rem">
                                        &nbsp;
                                        </th>
                                        <th
                                            @click.prevent="sortInvoiceItems('model')"
                                            :class="sortClass('model')"
                                            style="width: 10rem"
                                        >
                                            Model
                                        </th>
                                        <th
                                            @click.prevent="sortInvoiceItems('size')"
                                            :class="sortClass('size')"
                                            style="width: 5rem"
                                        >
                                            Size
                                        </th>
                                        <th
                                            style="width: 22rem"
                                            @click.prevent="sortInvoiceItems('description')"
                                            :class="sortClass('description')"
                                        >
                                            Description
                                        </th>
                                        <th
                                            style="width: 6rem"
                                            @click.prevent="sortInvoiceItems('quantity')"
                                            :class="sortClass('quantity')"
                                        >
                                            Qty
                                        </th>
                                        <th
                                            style="width: 10rem"
                                            @click.prevent="sortInvoiceItems('unit_price')"
                                            :class="sortClass('unit_price')"
                                        >
                                            Unit Price
                                        </th>
                                        <th
                                            class="money-col"
                                            style="width: 10rem"
                                            @click.prevent="sortInvoiceItems('total')"
                                            :class="sortClass('total')"
                                        >
                                            Total Price
                                        </th>
                                        <th class="td-options" />
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>&nbsp;</td>
                                        <td colspan="5">
                                            <select
                                                class="form-control"
                                                v-model="form.service_fee_text"
                                                @change="calculateServiceFee"
                                            >
                                                <option
                                                    value=""
                                                    disabled
                                                >
                                                    Choose service fee...
                                                </option>
                                                <option value="Annual Service">
                                                    Annual Service
                                                </option>
                                                <option value="Call Out Fee">
                                                    Call Out Fee
                                                </option>
                                            </select>
                                        </td>
                                        <td class="money-col">
                                            <div class="input-group">
                                                <div class="input-group-prepend">
                                                    <span class="input-group-text">£</span>
                                                </div>
                                                <input
                                                    type="number"
                                                    step="0.01"
                                                    min="0"
                                                    v-model="form.service_fee_price"
                                                    class="form-control text-right"
                                                    @change="invoiceServiceItemsChanged"
                                                >
                                            </div>
                                        </td>
                                    </tr>

                                    <tr>
                                        <td>&nbsp;</td>
                                        <td colspan="4">
                                            Postcode Service Fee Per Unit
                                        </td>
                                        <td
                                            v-if="form.service_unit_price"
                                            class="money-col"
                                        >
                                            <div class="input-group">
                                                <div class="input-group-prepend">
                                                    <span class="input-group-text">£</span>
                                                </div>
                                                <input
                                                    type="text"
                                                    v-model="form.service_unit_price"
                                                    class="form-control text-right"
                                                    readonly
                                                >
                                            </div>
                                        </td>
                                        <td />
                                        <td />
                                    </tr>
                                </tbody>
                                <draggable
                                    v-model="form.invoice_service_items"
                                    tag="tbody"
                                    handle=".drag-handle"
                                >
                                    <tr
                                        v-for="(item, index) in form.invoice_service_items"
                                        :key="index"
                                    >
                                        <td class="drag-handle-col">
                                            <span class="drag-handle">
                                                <i class="fas fa-arrows-alt-v" />
                                            </span>
                                        </td>
                                        <td>
                                            <input
                                                type="text"
                                                v-model="item.model"
                                                class="form-control"
                                                placeholder="Model"
                                            >
                                        </td>

                                        <td>
                                            <input
                                                type="text"
                                                v-model="item.size"
                                                class="form-control"
                                                placeholder="Size"
                                            >
                                        </td>

                                        <td>
                                            <input
                                                type="text"
                                                v-model="item.description"
                                                class="form-control"
                                                placeholder="Description"
                                            >
                                        </td>

                                        <td>
                                            <input
                                                type="text"
                                                v-model="item.quantity"
                                                class="form-control"
                                                placeholder="Qty"
                                                @change="invoiceServiceItemChanged(index)"
                                            >
                                        </td>

                                        <td class="money-col">
                                            <div class="input-group">
                                                <div class="input-group-prepend">
                                                    <span class="input-group-text">£</span>
                                                </div>
                                                <input
                                                    type="text"
                                                    v-model="item.unit_price"
                                                    class="form-control text-right"
                                                    placeholder="Unit price"
                                                    @change="invoiceServiceItemChanged(index)"
                                                >
                                            </div>
                                        </td>

                                        <td class="money-col">
                                            <div class="input-group">
                                                <div class="input-group-prepend">
                                                    <span class="input-group-text">£</span>
                                                </div>
                                                <input
                                                    type="text"
                                                    v-model="item.total"
                                                    class="form-control text-right"
                                                    placeholder="Total price"
                                                    readonly
                                                >
                                            </div>
                                        </td>
                                        <td class="td-options">
                                            <button
                                                class="btn btn-outline-danger btn-small"
                                                @click.prevent="removeInvoiceItem(index)"
                                                type="button"
                                            >
                                                <i class="fa fa-times" />
                                            </button>
                                        </td>
                                    </tr>
                                </draggable>

                                <tfoot>
                                    <tr>
                                        <td
                                            colspan="6"
                                            class="text-right"
                                        >
                                            Services and goods total:
                                        </td>
                                        <td class="money-col">
                                            <div class="input-group">
                                                <div class="input-group-prepend">
                                                    <span class="input-group-text">£</span>
                                                </div>
                                                <input
                                                    type="text"
                                                    v-model="form.invoice_service_items_total"
                                                    class="form-control text-right"
                                                    readonly
                                                >
                                            </div>
                                        </td>
                                        <td />
                                    </tr>
                                </tfoot>
                            </table>

                            <div class="row">
                                <div class="col-12 text-right">
                                    <button
                                        class="btn btn-info btn-small"
                                        @click.prevent="autoAddServiceItems()"
                                        type="button"
                                    >
                                        <i class="fa fa-calculator" /> Auto-add Service Items
                                    </button>
                                    <button
                                        class="btn btn-outline-info btn-small"
                                        @click.prevent="addInvoiceItem()"
                                        type="button"
                                    >
                                        <i class="fa fa-plus" /> Add Item
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-12">
                            <h3>Products and Services</h3>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-12 col-md-10">
                            <label>Does the customer require any other products or services?</label>
                        </div>
                        <div class="col-sm-12 col-md-2">
                            <select
                                v-model="form.require_other_products"
                                class="form-control"
                                @change="requireOtherProductsChanged"
                            >
                                <option
                                    value=""
                                    disabled
                                >
                                    Select
                                </option>
                                <option>Yes</option>
                                <option>No</option>
                            </select>
                        </div>
                    </div>

                    <div
                        class="row"
                        v-if="form.require_other_products === 'Yes'"
                    >
                        <div class="col-sm-12">
                            <table class="table table--fixed">
                                <thead>
                                    <th>Product Code</th>
                                    <th>Description</th>
                                    <th>Quantity</th>
                                    <th class="money-col">
                                        Unit Price
                                    </th>
                                    <th class="money-col">
                                        Total Price
                                    </th>
                                    <th style="width: 3em">
                                    &nbsp;
                                    </th>
                                </thead>
                                <tbody>
                                    <tr
                                        v-for="(product, index) in form.other_products"
                                        :key="index"
                                    >
                                        <td>
                                            <span>{{ product.code }}</span>
                                            <img
                                                v-if="product.photo_url"
                                                :src="product.photo_url"
                                                :alt="product.name"
                                                class="product-image"
                                            >
                                        </td>
                                        <td>
                                            <h4>{{ product.name }}</h4>
                                            <div>{{ product.text }}</div>
                                            <div>
                                                <input
                                                    type="text"
                                                    v-model="product.location"
                                                    class="form-control"
                                                    placeholder="Location"
                                                >
                                            </div>
                                        </td>
                                        <td>
                                            <input
                                                type="number"
                                                step="1"
                                                min="1"
                                                v-model="product.quantity"
                                                class="form-control"
                                                @change="otherProductChanged(index)"
                                            >
                                        </td>
                                        <td class="text-right money-col">
                                            <div class="input-group">
                                                <div class="input-group-prepend">
                                                    <span class="input-group-text">£</span>
                                                </div>
                                                <input
                                                    type="number"
                                                    step="0.01"
                                                    min="0"
                                                    v-model="product.unit_price"
                                                    @change="otherProductChanged(index)"
                                                    class="text-right form-control"
                                                >
                                            </div>
                                        </td>
                                        <td class="text-right money-col">
                                            <div class="input-group">
                                                <div class="input-group-prepend">
                                                    <span class="input-group-text">£</span>
                                                </div>
                                                <input
                                                    type="number"
                                                    :value="product.total_price"
                                                    readonly
                                                    class="text-right form-control"
                                                >
                                            </div>
                                        </td>
                                        <td>
                                            <button
                                                class="btn btn-outline-danger btn-small"
                                                @click.prevent="removeOtherProduct(index)"
                                                type="button"
                                            >
                                                <i class="fa fa-times" />
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                                <tfoot>
                                    <tr>
                                        <td
                                            colspan="4"
                                            class="text-right underlined"
                                        >
                                            Total
                                        </td>
                                        <td class="text-right">
                                            <div class="input-group">
                                                <div class="input-group-prepend">
                                                    <span class="input-group-text">£</span>
                                                </div>
                                                <input
                                                    type="number"
                                                    readonly
                                                    :value="form.other_products_total"
                                                    class="text-right form-control"
                                                >
                                            </div>
                                        </td>
                                        <td>&nbsp;</td>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-12 text-right">
                            <button
                                class="btn btn-info"
                                @click.prevent="addOtherProduct"
                            >
                                <i class="fa fa-plus" />
                                Add Line
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-12">
                            <h3>Notes</h3>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-12">
                            <textarea
                                v-model="form.notes"
                                placeholder="Write notes here..."
                                rows="3"
                                class="form-control"
                            />
                        </div>
                    </div>
                </div>
            </div>

            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-12">
                            <h3>Quotation Next Step</h3>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12">
                            <table class="table table--fixed">
                                <tr>
                                    <th>Sub Total</th>
                                    <td class="text-right money-col">
                                        <div class="input-group">
                                            <div class="input-group-prepend">
                                                <span class="input-group-text">£</span>
                                            </div>
                                            <input
                                                type="number"
                                                readonly
                                                :value="form.sub_total"
                                                class="form-control text-right"
                                            >
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <th>VAT @ 20%</th>
                                    <td class="text-right money-col">
                                        <div class="input-group">
                                            <div class="input-group-prepend">
                                                <span class="input-group-text">£</span>
                                            </div>
                                            <input
                                                type="number"
                                                readonly
                                                :value="form.vat"
                                                class="form-control text-right"
                                            >
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <th>Total</th>
                                    <td class="text-right money-col">
                                        <div class="input-group">
                                            <div class="input-group-prepend">
                                                <span class="input-group-text">£</span>
                                            </div>
                                            <input
                                                type="number"
                                                readonly
                                                :value="form.total"
                                                class="form-control text-right"
                                            >
                                        </div>
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-10">
                            <label for="form_installation_today">Customer happy with engineer to carry out installation
                                today</label>
                        </div>
                        <div class="col-sm-2 text-right">
                            <label class="form-check-label">Yes
                                <input
                                    id="form_installation_today"
                                    type="checkbox"
                                    v-model="form.installation_today"
                                    class="inline-control"
                                >
                            </label>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-9">
                            <label>Customer happy book works to be carried out at</label>
                        </div>
                        <div class="col-sm-3">
                            <date-picker
                                v-model="form.book_works"
                                :options="{format: 'L'}"
                            />
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-10">
                            <label for="form_contact_office">Customer will contact the office to book
                                appointment</label>
                        </div>
                        <div class="col-sm-2 text-right">
                            <label class="form-check-label">Yes
                                <input
                                    type="checkbox"
                                    id="form_contact_office"
                                    v-model="form.contact_office"
                                    class="inline-control"
                                >
                            </label>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-9">
                            <label>Quotation needs to be sent by email to</label>
                        </div>
                        <div class="col-sm-3">
                            <input
                                type="email"
                                v-model="form.quotation_email"
                                class="form-control"
                                placeholder="customer@email.com"
                            >
                        </div>
                    </div>

                    <p class="font-weight-bold text-center my-4">
                        IF RAMS ARE NEEDED PLEASE REQUEST THESE UPON ACCEPTING THE QUOTATION, ABORTED CALLS FOR NO RAMS
                        WILL BE CHARGED FOR IF RAMS WERENT REQUESTED. THANK YOU
                    </p>
                </div>
            </div>

            <audit-rows
                title="Photos"
                v-model="form.report_rows"
            />

            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-8">
                            <label class="top">Engineer Signature:</label>
                            <br>
                            <user-select
                                v-model="form.engineer_id"
                                :office="false"
                                :admins="false"
                            />
                        </div>
                        <div class="col-sm-12 col-md-6 col-lg-4 form-group">
                            <label
                                for="engineer_sign_date"
                                class="top"
                            >Date</label>
                            <br>
                            <date-picker
                                v-model="form.engineer_sign_date"
                                id="engineer_sign_date"
                                :options="{format: 'L'}"
                                required
                            />
                            <error
                                :errors="errors"
                                name="engineer_sign_date"
                            />
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-12 col-lg-4">
                            <label class="top">Customer Signature:</label>
                            <br>
                            <signature
                                v-if="!form.customer_signature"
                                ref="customerSignature"
                            />
                            <img
                                v-if="form.customer_signature"
                                :src="form.customer_signature"
                                alt="Customer signature"
                            >
                        </div>
                        <div class="col-sm-12 col-md-6 col-lg-4 form-group">
                            <label
                                for="customer_sign_name"
                                class="top"
                            >Customer Name</label>
                            <br>
                            <input
                                type="text"
                                v-model="form.customer_sign_name"
                                id="customer_sign_name"
                                name="customer_sign_name"
                                placeholder="Customer Name"
                                class="form-control"
                            >
                            <error
                                :errors="errors"
                                name="customer_sign_name"
                            />
                        </div>
                        <div class="col-sm-12 col-md-6 col-lg-4 form-group">
                            <label
                                for="customer_sign_date"
                                class="top"
                            >Date</label>
                            <br>
                            <date-picker
                                v-model="form.customer_sign_date"
                                id="customer_sign_date"
                                :options="{format: 'L'}"
                                required
                            />
                            <error
                                :errors="errors"
                                name="customer_sign_date"
                            />
                        </div>
                    </div>
                </div>
            </div>

            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-12 col-md-10">
                            <label for="">Is this complete and ready to send?</label>
                        </div>
                        <div class="col-sm-12 col-md-2 text-right">
                            <select
                                v-model="form.is_complete"
                                class="form-control"
                                required
                            >
                                <option :value="null">
                                    Select option
                                </option>
                                <option :value="false">
                                    No
                                </option>
                                <option :value="true">
                                    Yes
                                </option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card">
                <div class="card-body">
                    <div class="row form-group">
                        <div class="col-12">
                            <button
                                class="btn btn-success"
                                type="submit"
                                :disabled="isSaving || isLoading"
                            >
                                Save
                            </button>

                            <button
                                class="btn btn-outline-danger"
                                type="button"
                                @click.prevent="deleteForm()"
                                :disabled="isSaving || isLoading"
                                v-if="form.id && canDelete"
                            >
                                <i class="fa fa-times" /> Delete
                            </button>

                            <a
                                class="btn btn-info"
                                v-if="form.id"
                                :href="'/api/forms/' + form.id + '/stream'"
                                target="_blank"
                            >
                                <i class="fa fa-print" /> Preview/Print
                            </a>

                            <a
                                class="btn btn-info"
                                v-if="form.id"
                                :href="'/api/forms/' + form.id + '/download'"
                                target="_blank"
                                :download="form.doc_no + '.pdf'"
                            >
                                <i class="fa fa-file" /> Download PDF
                            </a>

                            <router-link
                                class="btn btn-info"
                                v-if="form.id"
                                :to="{name: 'office.emails.new', params: {customer_id: form.customer_id}, query: {form_id: form.id}}"
                            >
                                <i class="fa fa-envelope" /> Send to Customer
                            </router-link>

                            <router-link
                                :to="{name: 'engineer.jobs.show', params: {id: form.job_id}}"
                                class="btn btn-info"
                                v-if="$route.name === 'engineer.forms.edit' && form.job_id"
                            >
                                <i class="fa fa-chevron-left" /> Back to Job
                            </router-link>

                            <router-link
                                :to="{name: 'office.jobs.show', params: {id: form.job_id}}"
                                class="btn btn-info"
                                v-if="$route.name === 'office.forms.edit' && form.job_id"
                            >
                                <i class="fa fa-briefcase" /> View Job
                            </router-link>

                            <customer-site-footer-links
                                :customer-id="form.customer_id"
                                :site-id="form.site_id"
                            />

                            <activity-log
                                v-if="form.id"
                                :id="form.id"
                                model="Form"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </form>

        <b-modal
            ref="otherProductModal"
            title="Add Product Line"
            @ok="selectNewOtherProduct"
        >
            <div>
                <label for="search-product">Search for a product/service to add</label>
                <products-search 
                    v-model="newOtherProduct" 
                    :customer-id="form.customer_id"
                />
            </div>
            <hr>
            <div>
                <label for="new-other-product">or choose which product/service to add:</label>
                <products-select
                    id="new-other-product"
                    v-model="newOtherProduct"
                    type="object"
                    :customer-id="form.customer_id"
                />
            </div>
        </b-modal>
    </div>
</template>

<script>
import CustomerSearch from '../CustomerSearch';
import UsesErrors from '../../mixins/UsesErrors';
import UsesInfoMessage from '../../mixins/UsesInfoMessage';
import Sortables from '../../mixins/Sortables';
import UsesFormRouteQuery from '../../mixins/UsesFormRouteQuery';
import draggable from 'vuedraggable';
import ServiceProductsService from "../../services/ServiceProductsService";
import SiteService from '../../services/SitesService';
import PostcodeFeeService from '../../services/PostcodeFeeService';
import OtherProductsService from '../../services/ProductsService';
import DatePicker from "../DateTimePickerComponent.vue";
import Signature from "../SignatureComponent.vue";
import Service from '../../services/FormService';
import JobService from '../../services/JobService';
import InvoiceForm from './parts/InvoiceFormComponent';
import ProductsSelect from '../ProductsSelectComponent';
import ProductsSearch from '../ProductSearchComponent';
import axios from 'axios';
import SelectRowComponent from "./parts/SelectRowComponent.vue";
import AuditRows from "./parts/AuditRows.vue";

export default {
    components: {
        AuditRows,
        SelectRowComponent,
        CustomerSearch,
        draggable,
        DatePicker,
        Signature,
        InvoiceForm,
        ProductsSelect,
        ProductsSearch,
    },
    mixins: [
        UsesErrors,
        UsesInfoMessage,
        Sortables,
        UsesFormRouteQuery,
    ],
    data() {
        return {
            form: {
                type: 'recommendations',
                customer: {},
                service_items: [
                    {},
                ],
                invoice_service_items: [],
                require_other_products: 'Yes',
                other_products: [],
                other_products_total: 0.00,
                book_works: '',
                invoice_service_items_total: 0.00,
                sub_total: 0.00,
                vat: 0.00,
                total: 0.00,
                engineer_sign_date: window.moment(),
                customer_sign_date: window.moment(),
                is_complete: null,
                report_rows: [],
            },
            serviceProducts: [],
            siteServiceItems: [],
            otherProducts: [],
            newOtherProduct: {},
            token: null,
        };
    },

    computed: {
        canDelete() {
            return window.AuthService.user.admin_access || window.AuthService.user.office_access;
        },
    },

    mounted() {
        this.loadServiceProducts();
        this.loadOtherProducts();

        this.populateFormFromRouteQuery();

        if (this.$route.params.id) {
            const id = this.$route.params.id;
            this.loadForm(id);
        } else {
            Service.nextNo().then(res => {
                this.form.doc_no = res.data;
            });
        }
    },

    methods: {
        loadForm(id) {
            this.setLoading();
            Service.get(id).then(res => {
                this.form = res.data;

                if (!this.form.customer) {
                    this.form.customer = {
                        company_name: '',
                    };
                }

                if (!this.form.service_items) {
                    this.form.service_items = [
                        {},
                    ];
                }
                if (!this.form.invoice_service_items) {
                    this.form.invoice_service_items = [];
                }
                if (!this.form.invoice_part_items) {
                    this.form.invoice_part_items = [];
                }

                if (!this.form.other_products) {
                    this.form.other_products = [];
                }

                if (!this.form.report_rows) {
                    this.form.report_rows = [];
                }

                if (!this.form.service_fee_text) {
                    this.form.service_fee_text = '';
                }
                if (res.data.engineer_sign_date) {
                    this.form.engineer_sign_date = window.moment(res.data.engineer_sign_date);
                } else {
                    this.form.engineer_sign_date = window.moment();
                }
                if (res.data.customer_sign_date) {
                    this.form.customer_sign_date = window.moment(res.data.customer_sign_date);
                } else {
                    this.form.customer_sign_date = window.moment();
                }

                if (!this.form.invoice_service_items_total) {
                    this.form.invoice_service_items_total = 0.00;
                }
                if (!this.form.other_products_total) {
                    this.form.other_products_total = 0.00;
                }
                if (!this.form.sub_total) {
                    this.form.sub_total = 0.00;
                }
                this.getJobs();
                this.loadSiteItems();
                this.siteChanged();
                this.calculateServiceFee();
                this.calcOtherProductsTotal();
                this.calculateTotals();
            }).catch(err => {
                this.setErrorMessage('Could not load form');
                throw err;
            }).then(() => {
                this.clearLoading();
            });
        },

        onJobLoadedFromRoute() {
            this.siteChanged();
            this.getJobs();
        },

        getJobs() {
            if (!this.form.customer_id) {
                this.jobs = [];
                this.form.job_id = null;
                return;
            }
            JobService.search({'filter[customer_id]': this.form.customer_id}).then(res => {
                this.jobs = res.data.data || [];
            }, err => {
                this.setErrorMessage('Could not load customer jobs');
                this.jobs = [];
                throw err;
            });
        },

        saveForm() {
            this.setSaving();
            this.clearErrors();
            if (this.$refs.customerSignature && !this.$refs.customerSignature.isEmpty()) {
                this.form.customer_signature = this.$refs.customerSignature.toPng();
            }

            let data = {...this.form};
            delete data['customer'];
            delete data['site'];
            delete data['job'];
            delete data['data'];

            if (this.form.id) {
                Service.update(data).then(
                    res => {
                        this.clearSaving();
                        this.setInfoMessage("Form saved successfully");
                        this.$emit('formSaved', res.data);
                    },
                    err => {
                        this.clearSaving();
                        this.captureRequestErrors(err);
                    }
                );
            } else {
                Service.create(data).then(
                    res => {
                        this.clearSaving();
                        this.setInfoMessage("Form saved successfully");
                        if (this.$route.path.includes('engineer/')) {
                            this.$router.push({
                                name: "engineer.forms.edit",
                                params: {
                                    id: res.data.id
                                }
                            });
                        } else {
                            this.$router.push({
                                name: 'office.forms.edit',
                                params: {
                                    id: res.data.id
                                }
                            });
                        }
                    },
                    err => {
                        this.clearSaving();
                        this.captureRequestErrors(err);
                    }
                );
            }
        },

        deleteForm() {
            if (confirm("Are you sure you want to delete this form?")) {
                Service.delete(this.form).then(
                    () => {
                        this.setInfoMessage("Form successfully deleted");
                        this.$router.push({name: 'office.forms.search'});
                    },
                    error => {
                        this.setErrorMessage("Could not delete this form");
                        console.error(error);
                    }
                )
            }
        },

        loadServiceProducts() {
            ServiceProductsService.index({ customer_id: this.form.customer_id }).then(
                xhr => {
                    this.serviceProducts = xhr.data;
                },
                () => {
                    this.setInfoMessage('Failed to load service products');
                }
            )
        },

        loadOtherProducts() {
            OtherProductsService.index({ customer_id: this.form.customer_id }).then(res => {
                this.otherProducts = res.data;
            })
        },

        customerChanged(newCustomer) {
            if (!newCustomer) {
                this.form.customer = {};
                this.form.customer_id = null;
                this.form.site_id = null;
                this.siteChanged();
                return;
            }
            this.form.customer = newCustomer;
            this.form.customer_id = newCustomer.id;
            this.loadServiceProducts();
            this.loadOtherProducts();
            if (newCustomer && newCustomer.sites) {
                if (!newCustomer.sites.map(site => site.id).includes(this.form.site_id)) {
                    this.form.site_id = '';
                    this.siteChanged();
                }
            } else {
                this.form.site_id = '';
                this.siteChanged();
            }
        },

        siteChanged() {
            this.loadSiteServiceItems();
            this.calculateServiceFee();
        },

        loadSiteServiceItems() {
            if (typeof this.form.site_id === 'undefined' || !this.form.site_id) {
                this.siteServiceItems = [];
                return;
            }

            SiteService.get(this.form.site_id).then(res => {
                this.siteServiceItems = res.data.service_items || [{}];
            });
        },

        calculateServiceFee() {
            const site_id = this.form.site_id;
            PostcodeFeeService.search({
                site_id: site_id,
                customer_id: this.form.customer_id,
            }).then(res => {
                if (!res.data) {
                    this.setInfoMessage('Could not find a service postcode for this site');
                    return;
                }

                const postcodeFee = res.data[0];
                if (postcodeFee !== null && typeof postcodeFee !== 'undefined') {
                    this.form.service_fee_price = parseFloat(postcodeFee.service_fee).toFixed(2);
                    this.form.service_unit_price = parseFloat(postcodeFee.unit_fee).toFixed(2);
                }

                this.$forceUpdate();
            });
        },

        quoteRequiredChanged() {
            if (this.form.quote_required !== 'Yes') {
                this.form.site_already_serviced = null;
            }
        },

        sortServiceItems(key) {
            this.form.service_items = this.sortItems(key, this.form.service_items);
            this.$forceUpdate();
        },

        serviceItemChanged() {
            this.calculateServiceItemTotals();
        },

        removeServiceItem(index) {
            const confirm = window.confirm('Are you sure you want to delete this item?');
            if (!confirm) {
                return;
            }
            this.form.service_items.splice(index, 1);
            this.calculateServiceItemTotals();
        },

        calculateServiceItemTotals() {
            var water_total = 0;
            var foam_total = 0;
            var powder_total = 0;
            var co2_total = 0;
            var wet_chem_total = 0;
            var fire_blanket_total = 0;
            var hoses_total = 0;
            var screamer_alarm_total = 0;

            var fitting_fitted = 0;
            var id_sign_fitted = 0;

            var fitting_required = 0;
            var id_sign_required = 0;

            for (let i = 0; i < this.form.service_items.length; i++) {
                var item = this.form.service_items[i];
                if (!item.product_id) {
                    continue;
                }

                var product = this.findServiceProduct(item.product_id);

                if (typeof product === 'undefined') {
                    continue;
                }

                if (item.non_main) {
                    continue;
                }

                var name = product.name.toLowerCase();
                if (name.includes('water')) {
                    water_total++;
                }
                if (name.includes('foam')) {
                    foam_total++;
                }
                if (name.includes('co2')) {
                    co2_total++;
                }
                if (name.includes('powder')) {
                    powder_total++;
                }
                if (name.includes('blanket')) {
                    fire_blanket_total++;
                }
                if (name.includes('wet chem')) {
                    wet_chem_total++;
                }
                if (name.includes('hose')) {
                    hoses_total++;
                }
                if (name.includes('screamer')) {
                    screamer_alarm_total++;
                }
                if (item.fitting === 'Fitted') {
                    fitting_fitted++;
                }
                if (item.id_sign === 'Fitted') {
                    id_sign_fitted++;
                }
                if (item.fitting === 'Required') {
                    fitting_required++;
                }
                if (item.id_sign === 'Required') {
                    id_sign_required++;
                }
            }

            this.form.water_total = water_total;
            this.form.foam_total = foam_total;
            this.form.powder_total = powder_total;
            this.form.co2_total = co2_total;

            this.form.fitting_fitted = fitting_fitted;
            this.form.id_sign_fitted = id_sign_fitted;

            this.form.wet_chem_total = wet_chem_total;
            this.form.blanket_total = fire_blanket_total;
            this.form.hoses_total = hoses_total;
            this.form.screamer_total = screamer_alarm_total;

            this.form.fitting_required = fitting_required;
            this.form.id_sign_required = id_sign_required;

            this.$forceUpdate();
        },

        loadSiteItems() {
            if (typeof this.form.site_id === 'undefined' || !this.form.site_id) {
                this.site_items = [];
                return;
            }

            SiteService.get(this.form.site_id).then(res => {
                this.site_items = res.data.service_items;
            });
        },

        addSiteItems() {
            if (this.form.service_items.length > 0) {
                var confirm = window.confirm('This will override service items added to this form, continue?');
                if (!confirm) {
                    return;
                }
            }
            this.form.service_items = this.siteServiceItems;

            this.$forceUpdate();

            this.calculateServiceItemTotals();
        },

        addServiceItem() {
            this.form.service_items.push({
                no: this.form.service_items.length + 1,
                id_sign: 'Present',
                fitting: 'Present',
            });
            this.$forceUpdate();
        },

        getServiceProductVariations(product_id) {
            var product = this.serviceProducts.find(product => product.id === product_id);
            if (typeof product === 'undefined') {
                return [];
            }

            return product.variations;
        },

        findServiceProduct(id) {
            return this.serviceProducts.find(product => {
                return product.id === parseInt(id);
            });
        },

        siteAlreadyServiceChanged() {
            if (this.form.site_already_serviced !== 'Yes') {
                return;
            }

            this.addSiteItems();
        },

        addInvoiceItem() {
            this.form.invoice_service_items.push({});
            this.$forceUpdate();
        },

        removeInvoiceItem(index) {
            const confirm = window.confirm('Are you sure you want to delete this item?');
            if (!confirm) {
                return;
            }
            this.form.invoice_service_items.splice(index, 1);
            this.invoiceServiceItemsChanged();
            this.$forceUpdate();
        },

        autoAddServiceItems() {
            let confirm;
            if (this.form.invoice_service_items) {
                confirm = window.confirm('Auto-adding service items will clear any existing invoice service items, continue?');
            } else {
                confirm = true;
            }

            if (!confirm) {
                return;
            }

            let invoice_service_items = [];
            let items = [];
            for (let i = 0; i < this.form.service_items.length; i++) {
                let service_item = this.form.service_items[i];

                let size = service_item.size;
                let unit_price = 0;
                let description = [];
                var model = '';

                if (service_item.bs) {
                    description.push('Basic Service');
                }

                if (service_item.rc) {
                    description.push('Recharge/Refill');
                }

                if (service_item.es) {
                    description.push('Extended Service');
                }

                if (service_item.rcon) {
                    description.push('Recon');
                }

                if (service_item.new) {
                    description.push('New');
                }

                if (service_item.non_main) {
                    description.push('Non-maintained');
                }

                var product = this.serviceProducts.find(product => {
                    return product.id === service_item.product_id;
                });

                if (service_item.fitting === 'Required') {
                    description.push("Fitting required");
                    unit_price += parseFloat(product.fitting_price);
                }

                if (service_item.id_sign === 'Required') {
                    description.push("ID sign required");
                    unit_price += parseFloat(product.id_sign_price);
                }

                if (typeof product !== 'undefined') {
                    model = product.name
                    product.variations.forEach(variation => {
                        if (variation.name.toLowerCase().replace(' ', '') === size.toLowerCase().replace(' ', '')) {
                            if (service_item.bs && variation.bs_price) {
                                if (typeof this.form.service_unit_price !== 'undefined') {
                                    unit_price += parseFloat(this.form.service_unit_price);
                                } else {
                                    unit_price += parseFloat(variation.bs_price);
                                }
                            }
                            if (service_item.rc && variation.rc_price) {
                                unit_price += parseFloat(variation.rc_price);
                            }
                            if (service_item.es && variation.es_price) {
                                unit_price += parseFloat(variation.es_price);
                            }
                            if (service_item.rcon && variation.rcon_price) {
                                unit_price += parseFloat(variation.rcon_price);
                            }
                            if (service_item.new && variation.new_price) {
                                unit_price += parseFloat(variation.new_price);
                            }
                        }
                    });
                }

                if (unit_price == 0) {
                    continue;
                }

                let item = {
                    model: model,
                    size: size,
                    unit_price: unit_price.toFixed(2),
                    description: description.join(', '),
                };

                items.push(item);
            }

            // Add items to invoice items
            items.forEach(item => {
                var exists = false;
                // Loop through existing invoice items...
                invoice_service_items.forEach(invoice_item => {
                    // Check if current item already exists in invoice list...
                    if (
                        invoice_item.description === item.description &&
                        invoice_item.size === item.size &&
                        invoice_item.model === item.model
                    ) {
                        invoice_item.quantity++;
                        exists = true;
                    }

                });
                // Items doesnt exist in invoice so add it
                if (!exists) {
                    item.quantity = 1;
                    invoice_service_items.push(item);
                }
            });

            // Calculate the total for all invoice items
            invoice_service_items.forEach(invoice_item => {
                let total = 0;
                if (invoice_item.quantity && invoice_item.unit_price) {
                    total = invoice_item.quantity * parseFloat(invoice_item.unit_price);
                }
                invoice_item.total = total.toFixed(2);
            });

            this.form.invoice_service_items = invoice_service_items;
            this.invoiceServiceItemsChanged();
        },

        /**
         * Called when any of the invoice service items change
         */
        invoiceServiceItemsChanged() {
            let total = 0;
            if (this.form.service_fee_price) {
                total += parseFloat(this.form.service_fee_price);
            }

            this.form.invoice_service_items.forEach(item => {
                total += parseFloat(item.total);
            })
            this.form.invoice_service_items_total = total.toFixed(2);
            this.$forceUpdate();
            this.calculateInvoiceTotals();
        },

        /**
         * Called when one invoice service item changes
         * @param index
         */
        invoiceServiceItemChanged(index) {
            var item = this.form.invoice_service_items[index];
            var total = 0;
            if (item.unit_price && item.quantity) {
                total = parseFloat(item.unit_price) * item.quantity;
            }
            this.form.invoice_service_items[index].total = total.toFixed(2);
            this.form.invoice_service_items[index].unit_price = parseFloat(item.unit_price).toFixed(2);
            this.invoiceServiceItemsChanged();
        },

        calculateInvoiceTotals() {
            var subtotal = 0;
            if (this.form.invoice_service_items_total) {
                subtotal += parseFloat(this.form.invoice_service_items_total);
            }
            if (this.form.invoice_parts_total) {
                subtotal += parseFloat(this.form.invoice_parts_total);
            }

            var vat_total = subtotal / 5;
            this.form.sub_total = subtotal.toFixed(2);
            this.form.vat_total = vat_total.toFixed(2);
            this.form.invoice_total = subtotal + vat_total;
            this.form.invoice_total = this.form.invoice_total.toFixed(2);
            this.$forceUpdate();
            this.calculateTotals();
        },

        requireOtherProductsChanged() {
            if (this.form.require_other_products === 'Yes') {
                return;
            }
            if (!this.form.other_products.length) {
                return;
            }
            var confirm = window.confirm('Are you sure you want to remove all other products?');
            if (!confirm) {
                this.form.require_other_products = 'Yes';
                return;
            }
            this.form.other_products = [];
        },

        otherProductChanged(index) {
            var product = this.form.other_products[index];
            product.total_price = (parseFloat(product.unit_price) * product.quantity).toFixed(2);
            this.form.other_products[index] = product;
            this.calcOtherProductsTotal();
            this.$forceUpdate();
        },

        calcOtherProductsTotal() {
            let total = 0;
            if (this.form.other_products) {
                this.form.other_products.forEach(product => {
                    total += parseFloat(product.total_price);
                })
                this.form.other_products_total = total.toFixed(2);
            }
            this.calculateTotals();
        },

        addOtherProduct() {
            this.loadOtherProducts();
            this.$refs.otherProductModal.show();
        },

        selectNewOtherProduct() {
            if (!this.form.other_products) {
                this.form.other_products = [];
            }
            var newLength = this.form.other_products.push({
                ...this.newOtherProduct,
                quantity: 1,
            });
            this.newOtherProduct = {};

            this.otherProductChanged(newLength - 1);
        },

        calculateTotals() {
            this.form.sub_total = (parseFloat(this.form.invoice_service_items_total) + parseFloat(this.form.other_products_total)).toFixed(2);
            this.form.vat = (parseFloat(this.form.sub_total) * .2).toFixed(2);
            this.form.total = (parseFloat(this.form.sub_total) + parseFloat(this.form.vat)).toFixed(2);
        },

        removeOtherProduct(index) {
            let confirm = window.confirm('Are you sure you want to delete this product/service?');
            if (!confirm) {
                return;
            }
            this.form.other_products.splice(index, 1);
            this.calcOtherProductsTotal();
        },

        saveSiteItems() {
            const confirm = window.confirm('Saving these items to the site might overwrite any existing items already saved to the site, do you wish to continue?');
            if (!confirm) {
                return;
            }
            axios.post(`/api/sites/${this.form.site_id}/service-items`, {
                service_items: this.form.service_items,
            }).then(({data}) => {
                this.setInfoMessage('Items saved to site successfully');
                this.siteServiceItems = data.service_items;
            }).catch((err) => {
                this.setErrorMessage('Failed to save items to site');
                console.error(err);
            })
        }
    },
};
</script>

<style lang="scss">
.items-fill-group {
    display: flex;
}

.service-list-table {
    td, th {
        padding: 4px 2px;
        font-size: 12px;
    }

    .td-no {
        width: 3rem;
    }

    .td-ltd {
        width: 5rem;
    }

    .td-size {
        width: 10rem
    }

    .td-location {
        width: 28em;
    }

    .td-bs,
    .td-rc,
    .td-es,
    .td-rcon,
    .td-new,
    .td-non-main {
        width: 3rem;
        text-align: center;
    }

    .td-bracket,
    .td-fitting,
    .td-sign {
        width: 6em;
    }

    .td-options {
        width: 3rem;
    }

    .form-control {
        padding: 2px;
        font-size: 1em;
        height: auto !important;
    }

    .btn {
        padding: 0 .4em;
    }
}

.service-invoice-items-table {
    .td-options {
        width: 3em;
    }
}

.invoice-parts-table {
    .td-options {
        width: 3em;
    }
}

.totals-table {
    float: right;
    margin-right: 48px;
    width: calc(100% - 48px);
    text-align: right;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/forms/RecommendationsFormComponent.vue